import { SizeType } from 'antd/lib/config-provider/SizeContext'
import { useEffect } from 'react'
import { Field } from 'react-final-form'

import { MulticolumnDropdown, MultiColumnSelectProps } from '../../components/MultiColumnDropdown'
import { FormControl } from '../../components/FormControl'
import { AntLabeledValue, Select, SelectOption, SelectProps } from '../../components/Select'
import { Text, TextProps } from '../../components/Text'
import { ThemeWrapper } from '../../components/theme'

type TextFieldProps = {
  error?: any
  onChange: (value: string | AntLabeledValue) => void
  options: SelectOption[]
  labelInValue?: boolean
} & TextProps

const TextField = ({ onChange, options, labelInValue, ...rest }: TextFieldProps) => {
  useEffect(() => {
    if (options.length === 1) {
      onChange(labelInValue ? options[0] : options[0].value)
    }
  }, [options, onChange, labelInValue])
  return (
    <Text
      {...rest}
      block
      className="select-single-item-text-field" // used in global style !
    >
      {options[0]?.label}
    </Text>
  )
}

type Props = {
  label?: string
  placeholder?: string
  size?: SizeType
  name: string
  options: SelectOption[]
  additionalProps?: MultiColumnSelectProps
  textFieldProps?: TextProps
  labelProps?: TextProps
  hideOnSingle?: boolean
  direction?: 'vertical' | 'horizontal'
  showMulticolumnDropdown?: boolean
}

export const SelectField = ({
  label,
  placeholder,
  size,
  name,
  options,
  additionalProps,
  textFieldProps,
  labelProps,
  direction,
  hideOnSingle = true,
  showMulticolumnDropdown = false
}: Props) => {
  return (
    <ThemeWrapper>
      <Field
        name={name}
        render={p => {
          if (hideOnSingle && options.length === 1) {
            return (
              <FormControl<TextFieldProps>
                {...p}
                component={TextField}
                options={options}
                label={label}
                labelProps={{
                  color: 'darkGray',
                  fontSize: '16px',
                  fontWeight: 'normal',
                  ...labelProps
                }}
                {...textFieldProps}
                labelInValue={additionalProps?.labelInValue}
              />
            )
          }
          if (showMulticolumnDropdown) {
            return (
              <FormControl<MultiColumnSelectProps>
                {...p}
                component={MulticolumnDropdown}
                options={options}
                size={size || 'middle'}
                placeholder={placeholder}
                label={label}
                labelProps={{
                  color: 'darkGray',
                  fontSize: '16px',
                  fontWeight: 'normal',
                  ...labelProps
                }}
                additionalProps={additionalProps}
                direction={direction}
              />
            )
          }
          return (
            <FormControl<SelectProps>
              {...p}
              component={Select}
              options={options}
              size={size || 'middle'}
              placeholder={placeholder}
              label={label}
              labelProps={{
                color: 'darkGray',
                fontSize: '16px',
                fontWeight: 'normal',
                ...labelProps
              }}
              additionalProps={additionalProps}
              direction={direction}
            />
          )
        }}
      />
    </ThemeWrapper>
  )
}
